module.exports = "<div class=\"text\">\n  <div class=\"layout\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/text/index.tpl.html
// module id = D5vJ
// module chunks = 1 2 3 5 8 10 11 12 21 22 25 26 27 28 29 32 34 35 37 38